export default "__VITE_ASSET__743468cf__"